import { mapToDateTimeRange } from '@modules/common/utils';
import { QuantifyQuery } from '@modules/quantify/store/types';
import { TimeRange } from 'v2/core/entities';
import { EQLProps } from 'v2/core/repository/eql/types';
import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';

export const getDeltaClause = (
  compareTo: QuantifyQuery['compareQuery'],
  duration: QuantifyQuery['duration'],
): EQLProps['delta'] => {
  if (!compareTo) {
    return;
  }

  if (compareTo.timerange) {
    return {
      type: 'timerange',
      value: mapToDateTimeRange(compareTo.timerange) as TimeRange,
    };
  }

  if (compareTo.previousPeriod) {
    return {
      type: 'deltaOffset',
      value: {
        aggregatePeriod: compareTo.previousPeriod.unit,
        multipler: compareTo.previousPeriod.value,
      },
    };
  }

  return {
    type: 'whereClause',
    value: compareTo.whereClause ?? EmptyWhereClause,
  };
};
